// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';



//import { preset } from 'vue-cli-plugin-vuetify-preset-basil/preset'

//import {VLazy} from 'vuetify/lib';


import VModal from 'vue-js-modal';


window.Vue = Vue;
//window.vuetify = vuetify;

Vue.use(VModal, {
    // dynamicDefault: {
    //   opened: function(){

    //     console.log("open");
    //   }
    // }
});




function formatData(number){

    let floatNum = parseFloat(number);
  
    
    if(floatNum < 1000)
    {
      return String(floatNum);
    }
    else
    {
      return floatNum.toLocaleString('ru');
    }
    
  }
  
  
  Vue.directive('numflip', {
         
    bind: function(el, binding) {
      //el.setAttribute("value", parseFloat(binding.value).toLocaleString('ru'));
      el.value = formatData(binding.value);
    },
    update: function (el, binding, vnode) {
      var numberAnimation = function(el, oldValue, newValue) {
        var start = null, duration = 200
        function step(timestamp) {
          if (!start) start = timestamp;
          var progress = timestamp - start;
          el.value = formatData(Math.round(oldValue + (newValue-oldValue)*progress/duration));
         // el.setAttribute("value", Math.round(oldValue + (newValue-oldValue)*progress/duration).toLocaleString('ru'));
          
          if (progress < duration) {
            window.requestAnimationFrame(step);
          } else {
            el.value = formatData(newValue);
            //el.setAttribute("value", newValue.toLocaleString('ru'));ы
          }
        }
        el.value =  formatData(oldValue);
        //el.setAttribute("value", oldValue.toLocaleString('ru'));
        window.requestAnimationFrame(step);
      };
     
      let value_input = parseFloat(el.value.replace(/[^\.\d]/g, ''));
     
     
      if((parseFloat(binding.value) != value_input || parseFloat(binding.value) != parseFloat(binding.oldValue)) && binding.value !== false) {
  
        
        //el.setAttribute("value", binding.value.toLocaleString('ru'));
        //console.log(el);
        numberAnimation(el, binding.oldValue, binding.value)
      }
    }
  });
  
import vuetify from '@/plugins/vuetify'; // path to vuetify export

import {VLazy, VSkeletonLoader, VTabs, VTab, VTabsItems, VTabItem, VAvatar, VRating, VBadge} from 'vuetify/lib';


import { register } from 'swiper/element/bundle';

register();

//import FileUpload from 'vue-upload-component';
const FileUpload = () => import('vue-upload-component');
const ListingCard = () => import ('@/components/listing-card');
const ListingCardMobile = () => import ('@/components/listing-card-mobile');
const ElementProductMobile = () => import ('@/components/page-product-mobile');
const ElementProduct = () => import ('@/components/page-product');
const VueSlider = () => import ('vue-slider-component');
//const StarRating = () => import ('vue-star-rating');
//const location = () => import ('@/components/location/template');

import location from '@/components/location/template';

//const UserField = () => import ('@/components/user-field/template');

import UserField from '@/components/user-field/template';


const VueSlickCarousel = () => import ('vue-slick-carousel');
const PopupProduct = () => import ('@/components/popup-product');
// const Feedbacks = () => import ('@/components/feedbacks-card');
// const feedback = () => import ('@/components/feedback');

// const FeedbacksMobile = () => import ('@/components/feedbacks-card-mobile');
// const feedbackMobile = () => import ('@/components/feedback-mobile');


const carousel = () => import ('@/components/carousel');
const carouselMobile = () => import ('@/components/carousel-mobile');
const catalogMobile = () => import ('@/components/catalog-mobile');
const pagination = () => import ('@/components/pagination');
//const lazyloadBlock = () => import ('@/components/lazyload-block');
//const dolyami = () => import ('@/components/dolyami');
const Vform = () => import ('@/components/v-form');
const carouselItems = () => import ('@/components/carousel-items');
//const vuebox = () => import ('@/components/vuebox');
// const quickResponse = () => import ('@/components/quick-response');
//import '@mdi/font/css/materialdesignicons.css';
//import * as mdijs from '@mdi/js'
//import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import { Carousel, Slide } from 'vue-snap';
import StarIcon from 'vue-material-design-icons/Star.vue';
// import 'vue-snap/dist/vue-snap.css';
//const PopupProduct = () => import ('@/components/popup-product');
//import VueSlider from 'vue-slider-component';
//import StarRating from 'vue-star-rating';
// import ListingCard from '@/components/listing-card';
// import ElementProduct from '@/components/page-product';
import catalog from '@/mixins/catalog';
import listingSearch from '@/components/listing-search';
import listingSearchMobile from '@/components/listing-search-mobile';
//import listingBase from '@/mixins/listing-base';

import * as yandexEcommerce from '@/utils/yandexEcommerce';

Vue.prototype.$ecommerce = yandexEcommerce;


//window.mixins = [catalog, listingBase];
//import VueSlick from 'vue-slick';
//import vTabs from 'vtabs';
//sconst Vuetify = () => import('vuetify/lib');
//import Vuetify from 'vuetify/lib';


//const VLazy = () => import('vuetify/lib');
//import Vuetify from 'vuetify';

//import vLazy from 'v-lazy';

//import location from '@/components/location/template';
//const vTabs = () => import('vtabs');
//import UserField from '@/components/user-field/template';
// import ListingCard from '@/components/listing-card';
// import ListingCardMobile from '@/components/listing-card-mobile';
//import VueSlickCarousel from 'vue-slick-carousel';
//import PopupProduct from '@/components/popup-product';
//import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// import axios from 'axios';
// window.axios = axios;




//console.log("wtf");


/* eslint-disable no-new */
// if(document.getElementById("vue-example")) {
//     const Example = require('./Example').default;

//     Vue.config.productionTip = false;

//     new Vue({
//         el: '#vue-example',
//         components: {Example},
//         template: '<Example/>',
//     });
// }






// export default new vuetify({
//   icons: {
//     iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
//   },
// });
//console.log(window.mixins);
//Vue.use(FileUpload);
//Vue.use(StarRating);
//Vue.use(VueSlick);
//Vue.use(VueSlickCarousel);
//Vue.use(vTabs);


// Vue.use(Vuetify, {

// });
//Vue.use(location);
//Vue.use(UserField);


//console.log(vuetify);

window.bus = new Vue();

if(typeof window.global_vue !== 'undefined')
{
    
    //console.log(window.global_vue);
    window.global_vue.forEach(function(item, index, array) {

      //console.log(item);

        item["vuetify"] = vuetify;
        //item = vuetify;
        item["components"] = {"file-upload":FileUpload, 
                              "vue-slider": VueSlider, 
                              //"star-rating":StarRating, 
                              //"vue-slick": VueSlick,
                              "element-product-mobile": ElementProductMobile,
                              "element-product":ElementProduct,
                              "carousel-items":carouselItems,
                              "catalog-mobile": catalogMobile,
                              "user-field":UserField,
                              "v-form":Vform,
                              "location":location,
                              "pagination":pagination,
                              "listing-search": listingSearch,
                              "listing-search-mobile":listingSearchMobile,
                              //"feedbacks-card":Feedbacks,
                             // "feedback":feedback,
                             // "feedbacks-card-mobile":FeedbacksMobile,
                              //"feedback-mobile":feedbackMobile,
                              "carousel":carousel,
                              "carousel-mobile":carouselMobile,
                               "v-lazy":VLazy,
                              // 'vuebox': vuebox,
                              // "v-skeleton-loader":VSkeletonLoader,
                              //"quick-response":quickResponse,
                              //"icons": mdijs,
                              StarIcon,
                              // "v-carousel":VCarousel,
                              // "v-carousel-item":VCarouselItem,
                              // "snap-carousel":Carousel,
                              //"slide":Slide,
                              //"tabs":vTabs,
                              "v-tab":VTab,
                              "v-tabs":VTabs,
                              "v-tabs-items":VTabsItems,
                              "v-tab-item":VTabItem,
                              "v-avatar":VAvatar,
                              "v-rating":VRating,
                              // "v-badge":VBadge,
                              "vue-slick-carousel":VueSlickCarousel,
                              "listing-card":ListingCard,
                              "listing-card-mobile":ListingCardMobile,
                              "popup-product":PopupProduct,
                              //"lazyload-block":lazyloadBlock,
                              //"dolyami":dolyami
                            };
                            //console.log(item["mixins"]);
        //  item["mixins"]                    
        //  window.mixins                    
        // item["mixins"] = [catalog];
        if(item["mixins"])
        {
            item["mixins"].forEach(element => {
              
              
              item["mixins"].push(window.mixins[element]);

              //console.log(window.mixins[element]);
            });
        }
       

       // let result = Object.assign({}, vuetify, item);
        //console.log(item);
        new Vue(item);
        
  });
    
  window.Vue = Vue;
  window.global_vue = [];


    
}